import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41500436"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-6 modal-card" }
const _hoisted_2 = ["id:number"]
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", { "id:number": _ctx.tokenId }, [
      _createElementVNode("img", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clickToken', _ctx.tokenId))),
        src: _ctx.img
      }, null, 8, _hoisted_3),
      _createElementVNode("h5", null, _toDisplayString(_ctx.name), 1)
    ], 8, _hoisted_2)
  ]))
}